var map = {
	"./execute-code-small.png": "mk46",
	"./file-dropbox.png": "iHlV",
	"./import-small.png": "T/c6",
	"./new-blank-small.png": "ceF9",
	"./off.png": "NrI0",
	"./on.png": "8qlF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/rNU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-data ^\.\/.*\.png$
// module id = /rNU
// module chunks = 46